const info = {
  ZH: { //中文翻译
    csymbol: "\u4F9B\u8D27\u7F16\u53F7",
    suppliercode: "\u4F9B\u5E94\u5546\u4EE3\u7801",
    tolerance: "\u96F6\u90E8\u4EF6\u504F\u5DEE",
    weight: "\u8D28\u91CF",
    save: "\u4FDD\u5B58",
    requireValidate:'非必填校验',
    componentClass: "零部件类别",
    mdsCode: "零部件/半成品/材料号",
    regenerate: "再生材料使用情况",
    fileUp:"上传附件",
    required:"必填",
    collapseTitle1:'材料代号标识、引用标准必填规则',
    collapseTitle2:'警告项拦截',
    collapseTitle3:'零部件信息偏差',
    collapseTitle4:'供货信息',
    collapseTitle5:'法规校验',
    label1:"材料代号",
    label2:"引用标准",
    label3:"材料分类：",
    label4:"材料重量：",
    savesuccess: "\u4FDD\u5B58\u6210\u529F",
    pleaseenteranumber: "\u8BF7\u8F93\u5165\u6570\u5B57",
    lengthjiaoyan: "\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC7490\u4E2A\u5B57\u7B26",
    tip: "\u8BF4\u660E\uFF1A\u68C0\u67E5\u53D1\u9001\u8868\u5355\u4EF6\u53F7\u662F\u5426\u4E0E\u6307\u5B9A\u89C4\u5219\u4E00\u81F4\u3002\u201CNS20140903\u201D\u5219\u4E3A\u7CBE\u786E\u5339\u914D\uFF0C\u82E5\u4E3A\u201CNS%\u201D\uFF0C\u5219\u4EE5NS\u5F00\u5934\u7684\u4EF6\u53F7\uFF0C\u82E5\u4E3A\u201CNS2014090?\u201D\uFF0C\u5219\u4EE5\u201CNS2014090\u201D\u4E3A\u5934\uFF0C\u5E26\u53E6\u5916\u4E00\u4E2A\u5B57\u7B26\u7684\u4EF6\u53F7\u3002\u201D%\u201D\u4E0E\u201D?\u201D\u5747\u4E3A\u534A\u89D2\u7B26\u53F7\u3002\u8BB0\u5F55\u6570\u53EF\u8FFD\u52A0\uFF0C\u82E5\u4E3A\u591A\u6761\u8BB0\u5F55\uFF0C\u4E3A\u6216\u5173\u7CFB\uFF0C\u5176\u4E2D\u4E00\u6761\u6EE1\u8DB3\u5373\u53EF\uFF0C\u586B\u5199\u65F6\u4EE5;\u53F7\u5206\u9694\uFF0C\u5982\uFF1ANS2014090?;NS2014090%",
    isuse: "\u662F\u5426\u4F7F\u7528\u81EA\u5B9A\u4E49\u6821\u9A8C\u89C4\u5219",
    mdsName: "\u4F9B\u8D27\u540D\u79F0",
    drawingId: "\u5236\u56FE\u53F7",
    drawingModCode: "\u5236\u56FE\u4FEE\u6539\u53F7",
    suppliertipTip: "\u8BF4\u660E\uFF1A\u68C0\u67E5\u53D1\u9001\u8868\u4F9B\u5E94\u5546\u4EE3\u7801\u662F\u5426\u4E0E\u6307\u5B9A\u89C4\u5219\u4E00\u81F4\u3002",
    mdsNameTip: " \u8BF4\u660E\uFF1A\u68C0\u67E5\u53D1\u9001\u8868\u4F9B\u8D27\u540D\u79F0\u662F\u5426\u4E0E\u6307\u5B9A\u89C4\u5219\u4E00\u81F4\u3002",
    drawingIdTip: " \u8BF4\u660E\uFF1A\u68C0\u67E5\u53D1\u9001\u8868\u5236\u56FE\u53F7\u662F\u5426\u4E0E\u6307\u5B9A\u89C4\u5219\u4E00\u81F4\u3002",
    drawingModCodeTip: " \u8BF4\u660E\uFF1A\u68C0\u67E5\u53D1\u9001\u8868\u5236\u56FE\u4FEE\u6539\u53F7\u662F\u5426\u4E0E\u6307\u5B9A\u89C4\u5219\u4E00\u81F4\u3002",
    authenticity: "\u662F\u5426\u5728\u4F9B\u5E94\u5546\u53D1\u9001\u754C\u9762\u542F\u7528\u4F9B\u5E94\u5546\u6570\u636E\u771F\u5B9E\u6027\u627F\u8BFA\u6309\u94AE",
    enName: " \u82F1\u6587\u540D\u79F0\u5FC5\u586B",
    matFlag: " \u6750\u6599\u4EE3\u53F7/\u6807\u8BC6\u5FC5\u586B",
    matFalgRefStd: " \u6750\u6599\u4EE3\u53F7/\u6807\u8BC6\u5F15\u7528\u6807\u51C6\u5FC5\u586B",
    uploadNewDocument: " \u4e0a\u4f20\u65b0\u6587\u6863",
    import: " \u5bfc\u5165",
    wait: "\u7a0d\u7b49",
    cancle: " \u53D6\u6D88",
    uploadFile: " \u4e0a\u4f20\u6587\u4ef6",
    saveMsg: " \u8bf7\u5148\u4fdd\u5b58",
    globalVerification: "  \u662F\u5426\u5168\u5C40\u6821\u9A8C",
    uploadFileRequirement: "\u4E0A\u4F20\u6587\u4EF6\u9650\u523620M",
    upload: " \u4E0A\u4F20",
    download: " \u4E0B\u8F7D",
    fileNameMsg: " \u672C\u4F01\u4E1AMDS\u586B\u62A5\u8981\u6C42",
    enable: "启用"
  },
  EN: { //英文翻译
    csymbol: "Designated Component No. by customer",
    suppliercode: "Supplier code",
    tip: 'explanation\: how to check if the part number sent to customer has conformed to the specified rules. Input \u201CNS20140903\u201D to get the exact match. Input \u201CNS%\u201D to find out the MDS whose number begin with "NS". Input \u201CNS2014090?\u201D to find out the MDS whose number begin with "NS2014090" and end up with a letter. Multiple records can be separated by ";".As long as one of them meet the demands, the part number can be conformed with the rules. For example,NS2014090?;NS2014090%.',
    tolerance: "Component mass deviation",
    weight: "weight",
    save: "Save",
    requireValidate:'Non mandatory verification',
    componentClass: "Component category",
    mdsCode: "Part number",
    regenerate: "Recyclate Information",
    fileUp:"Attachment",
    required:"required",
    collapseTitle1:'Material code identification and mandatory rules for referencing standards',
    collapseTitle2:'Warning item interception',
    collapseTitle3:'Deviation in component information',
    collapseTitle4:'Supply information',
    collapseTitle5:'Regulatory verification',
    label1:"Material",
    label2:"Referenced standards",
    label3:"Material classification:",
    label4:"Material weight:",
    savesuccess: "Save successful",
    pleaseenteranumber: "Please enter an number",
    lengthjiaoyan: "Length can't exceed 490 ",
    isuse: "Use user-defined checking rules",
    mdsName: "Designated Name by customer",
    drawingId: "	Drawing No.",
    drawingModCode: "	Drawing Change Level",
    suppliertipTip: " explanation\: how to check if the supplier sent to customer has conformed to the specified rules.",
    mdsNameTip: "  explanation\: how to check if the mdsName sent to customer has conformed to the specified rules.",
    drawingIdTip: " explanation\: how to check if the drawingId sent to customer has conformed to the specified rules.",
    drawingModCodeTip: "  explanation\: how to check if the drawingModCode sent to customer has conformed to the specified rules.",
    authenticity: "Enable the supplier data authenticity commitment button in the supplier sending interface",
    enName: "EN name",
    matFlag: " Material code/Symbol",
    matFalgRefStd: " Norms/Standards",
    uploadNewDocument: " upload new document",
    import: " Import",
    wait: "wait",
    cancle: "cancle",
    uploadFile: " upload file ",
    saveMsg: " please save it first",
    globalVerification: "  global verification",
    uploadFileRequirement: "  The maximum size of the uploaded file is 20M",
    upload: " upload",
    download: " download",
    fileNameMsg: " MDS filling requirements of the enterprise",
    enable: "Active"
  }
}
export default info //需要暴露出去
